import axiosInstance from './axiosInstance';

export async function getDashboardSummary() {
  const response = await axiosInstance.get('/dashboard/get-dashboard-summary.php');
  return response.data;
}